import React from 'react';
import { useIntl } from 'react-intl-next';
import { EngagementSpotlight } from '@atlassiansox/engagekit-ts';

import { SpotlightManager, SpotlightTarget } from '@atlaskit/onboarding';
import Button from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';

import { i18n } from '../AdvancedSearch-i18n.ts';

import { AtlassianIntelligenceIcon } from './atlassian-intelligence-icon.tsx';
import { AskAIButtonContainer, ToolTipOverride } from './smart-answers-styles.tsx';

export const AskAIButton = ({ onClick, isDisabled }) => {
	const intl = useIntl();
	const spotlightId = 'sain-ask-ai-button-advanced';

	const AIButton = (
		<AskAIButtonContainer>
			<SpotlightTarget name={spotlightId}>
				<Button
					onClick={onClick}
					isDisabled={isDisabled}
					iconBefore={<AtlassianIntelligenceIcon />}
				>
					{intl.formatMessage(i18n.askAIButton)}
				</Button>
			</SpotlightTarget>
			<EngagementSpotlight engagementId={spotlightId} />
		</AskAIButtonContainer>
	);

	return (
		<SpotlightManager>
			{isDisabled ? (
				<Tooltip
					content={intl.formatMessage(i18n.disabledAIButtonMessage)}
					position="top-start"
					component={ToolTipOverride}
				>
					{AIButton}
				</Tooltip>
			) : (
				AIButton
			)}
		</SpotlightManager>
	);
};
